module.exports = __webpack_public_path__ + "static/palmsad.b6156c8b.jpg";